 // doctor pages
import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "./styles/global.css";
import LogIn from "./pages/log_in";
import AddPatient from "./pages/add_patient";
import AddPatient_step2 from "./pages/add_patient_step2";
import AddState from "./pages/add_state";
import AddState2 from "./pages/add_state_step2";
import AddState3 from "./pages/add_state_step3";
import Main from './pages/Main';
import DoctorProfile from "./pages/doctor_profile";
import CreateAccount from "./pages/create_account";
import AccountPasswords from "./pages/create_account_step2";
import HospitalForm from "./pages/create_account_step3";
import PatientProfile from "./pages/patient_profile";
import Support from "./pages/support";
import Auth from "./pages/Auth";
import VisitDetails from "./pages/VisitDetails";
// admin pages
import Admin_Main from "./pages/Admin_Main";
import AccountsManager from "./pages/accounts_manager";
import AdminProfile from "./pages/admin_profile";
import AllAdmins from "./pages/all_admins";
import CreateAccountAdmin from "./pages/create_account_admin";
import AllPatients from "./pages/all_patients";
import SupportRequest from "./pages/SupportRequest";
import Admin_DashBoard from "./pages/Admin_DashBoard";
import LoginSupport from "./pages/LoginSupport";
import AdminsProfiles from "./pages/admins_profiles";
import AllDoctors from "./pages/all_doctors";
import CreateAccountDoctor from "./pages/create-doctor";
function App() {
  useEffect(() => {
    document.title = "dissyssy";
  }, []);
  const [formData, setFormData] = useState({
  name: "",
  diagnosis: "",
  state: "",
  weight: "",
  height: "",
  bloodPressure: "",
  bloodSugar: "",
  allergies: "",
  vaccines: "",
  diseases: "",
  surgeries: "",
  Sedimentation : "",
  whiteBloodCells: "",
  redBloodCells: "",
  covid: "",
  cancer: ""
});

  return (
    <Routes>
      
      <Route path="/" element={<LogIn />} />

      <Route path="/create-account-step2" element={<AccountPasswords />} />

      <Route path="/create-account-step3" element={<HospitalForm />} />

      <Route path="/create-account" element={<CreateAccount />} />

      <Route path="/add-patient" element={<AddPatient />} />

      <Route path="/add-patient-step2" element={<AddPatient_step2 />} />

      <Route path="/doctor" element={<DoctorProfile />} />
      
      <Route path="/doctor/:id" element={<DoctorProfile />} />

      <Route path="/add-state" element={<AddState formData={formData} setFormData={setFormData} />} />

      <Route path="/add-state-step2" element={<AddState2 formData={formData} setFormData={setFormData} />} />

      <Route path="/add-state-step3" element={<AddState3 formData={formData} setFormData={setFormData} />} />
          
      <Route path="/Main" element={<Main />} />

     <Route  path="/Support" element={<Support />} />

     {/* Admin Routes */}

     <Route path="/Admin_Main" element={<Admin_Main />} />

     <Route path="/accounts-manager" element={<AccountsManager />} />

     <Route path="/admin-profile" element={<AdminProfile />} />

     <Route path="/admins-profiles" element={<AllAdmins />} />

     <Route path="/create-account-admin" element={<CreateAccountAdmin />} />

     <Route path="/all-doctors" element={<AllDoctors />} />

     <Route path="/all-patients" element={<AllPatients />} />

     <Route path="/auth-verify-email" element={<Auth />} />
     
     <Route path="/visit/:id" element={<VisitDetails />} />

    <Route path="/support-request" element={<SupportRequest />} />

    <Route path="/admin-dashboard" element={<Admin_DashBoard />} />

    <Route path="/admins-profiles/:id" element={<AdminsProfiles />} />

    <Route path="/create-doctor" element={<CreateAccountDoctor />} />
     {/* shared Routes */}

     <Route path="/patient-profile/:id" element={<PatientProfile />} />
    <Route path="/login-support" element={<LoginSupport />} />
    </Routes>
  );
}

export default App;